import { BaseEntity } from 'yt-ng-framework';
export class PrometRobeZaKomitentaPoArtiklima extends BaseEntity {
    constructor() {
        super();
    }

    Vd: String = null;
    Broj: String = null;
    Datum: Date = null;
    RobaId: Number = null;
    RobaSifra: String = null;
    RobaNaziv: String = null;
    RobaJm: String = null;
    Ulaz: Number = null;
    Izlaz: Number = null;
    CenaDob: Number = null;
    CenaNab: Number = null;
    CenaProd: Number = null;
    PdvJm: Number = null;
    VrUlDob: Number = null;
    VrUlNab: Number = null;
    VrUlProd: Number = null;
    VrIzNab: Number = null;
    VrIzProd: Number = null;
    VrIzPdv: Number = null;
    KomitentNaziv: String = null;
    T01VrednostUlazaPoNabavnojCeni: Number = null;
    T02VrednostIzlazaArtikalaPoProsecnojNabavnojCeni: Number = null;
    T03VrednostIzlazaArtikalaPoProdajnojCeni: Number = null;
    T04UkupnoPdvIzlazRobe: Number = null;
    T05VrednostIzlazaArtikalaPoProdajnojCeniBezPdv: Number = null;
    T06RealizacijaDoUlozenogNovca: Number = null;
    T07UkupnoOstvarenaRazlikaUCeniNaKrajuPerioda: Number = null;

    Deserialize(input: any) {
        this.ID = input.ID;
        this.Vd = input.Vd;
        this.Broj = input.Broj;
        this.Datum = input.Datum;
        this.RobaId = input.RobaId;
        this.RobaSifra = input.RobaSifra;
        this.RobaNaziv = input.RobaNaziv;
        this.RobaJm = input.RobaJm;
        this.Ulaz = input.Ulaz;
        this.Izlaz = input.Izlaz;
        this.CenaDob = input.CenaDob;
        this.CenaNab = input.CenaNab;
        this.CenaProd = input.CenaProd;
        this.PdvJm = input.PdvJm;
        this.VrUlDob = input.VrUlDob;
        this.VrUlNab = input.VrUlNab;
        this.VrUlProd = input.VrUlProd;
        this.VrIzNab = input.VrIzNab;
        this.VrIzProd = input.VrIzProd;
        this.VrIzPdv = input.VrIzPdv;
        this.KomitentNaziv = input.KomitentNaziv;
        this.T01VrednostUlazaPoNabavnojCeni=input.T01VrednostUlazaPoNabavnojCeni;
        this.T02VrednostIzlazaArtikalaPoProsecnojNabavnojCeni=input.T02VrednostIzlazaArtikalaPoProsecnojNabavnojCeni;
        this.T03VrednostIzlazaArtikalaPoProdajnojCeni=input.T03VrednostIzlazaArtikalaPoProdajnojCeni;
        this.T04UkupnoPdvIzlazRobe=input.T04UkupnoPdvIzlazRobe;
        this.T05VrednostIzlazaArtikalaPoProdajnojCeniBezPdv=input.T05VrednostIzlazaArtikalaPoProdajnojCeniBezPdv;
        this.T06RealizacijaDoUlozenogNovca=input.T06RealizacijaDoUlozenogNovca;
        this.T07UkupnoOstvarenaRazlikaUCeniNaKrajuPerioda=input.T07UkupnoOstvarenaRazlikaUCeniNaKrajuPerioda;
        return this;
    }

    Serialize(input: PrometRobeZaKomitentaPoArtiklima) {
        return input;
    }

    blankIfZero(value) {
        return value == 0 ? "" : value;
    }

}   